export default __webpack_public_path__ + "static/media/markerAlert.075eb399.svg";